import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const CustomerIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const strokeColor = Colors24[color]
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3346 6.33333C13.3346 8.17428 11.8423 9.66667 10.0013 9.66667C8.16035 9.66667 6.66797 8.17428 6.66797 6.33333C6.66797 4.49238 8.16035 3 10.0013 3C11.8423 3 13.3346 4.49238 13.3346 6.33333Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0013 10.418C6.77964 10.418 4.16797 13.0296 4.16797 16.2513H15.8346C15.8346 13.0296 13.223 10.418 10.0013 10.418Z"
        stroke={strokeColor}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
